import { ringDashArray, todayScoreMeta } from "@/lib/today/explore";

export function ScoreRing({
  score,
  size,
  numberColor,
  caption = "GO",
  label = "GO score",
}: {
  score: number | null;
  size: number;
  numberColor?: string;
  caption?: string | null;
  label?: string;
}) {
  const meta = todayScoreMeta(score);
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="26" fill="none" stroke="#EDF1EC" strokeWidth="6" />
        {score !== null ? (
          <circle
            cx="32"
            cy="32"
            r="26"
            fill="none"
            stroke={meta.main}
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={ringDashArray(score)}
            transform="rotate(-90 32 32)"
          />
        ) : null}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center" aria-hidden="true">
        <span
          className="font-serif leading-[0.9]"
          style={{ color: numberColor ?? meta.main, fontSize: Math.round(size * 0.36) }}
        >
          {score ?? "·"}
        </span>
        {caption !== null ? (
          <span className="text-[7.5px] font-bold tracking-[0.14em] text-text-muted">{caption}</span>
        ) : null}
      </div>
      <span className="sr-only">
        {score === null ? "No score yet" : `${label} ${score} of 100`}
      </span>
    </div>
  );
}
